import React from 'react';

export function getAuthorizationContent() {
    return (
        <div>
            <h4>Acknowledgment and Authorization for Background Check</h4>
            <p>
                <span className="custom-text">
                    I acknowledge receipt of the separate documents entitled Disclosure Regarding Background Investigation and A Summary of Your Rights Under
                    the Fair Credit Reporting Act and certify that I have read and understand both of those documents. I hereby authorize the obtaining of
                    “consumer reports” and/or “investigative consumer reports” by the GreenLight (the “Company”) at any time after receipt of this authorization
                    and throughout my employment, if applicable. To this end, I hereby authorize any law enforcement agency, administrator, state or federal
                    agency, institution, school or university (public or private), information service bureau, past or present employers, motor vehicle records
                    agencies, or insurance company to furnish any and all background information requested by{' '}
                    <strong>
                        Checkr, Inc., One Montgomery Street, Suite 2000, San Francisco, CA 94104 | (844) 824-3257 |{' '}
                        <a href="https://checkr.com/applicant" target="_blank" rel="noopener noreferrer">
                            https://checkr.com/applicant
                        </a>
                    </strong>{' '}
                    and/or the Company. I agree that a facsimile (“fax”), electronic, or photographic copy of this Authorization shall be as valid as the
                    original.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>New York residents/applicants only:</strong> Upon request, you will be informed whether or not a consumer report was requested by
                    the Employer, and if such report was requested, informed of the name and address of the consumer reporting agency that furnished the report.
                    You have the right to inspect and receive a copy of any investigative consumer report requested by the Employer by contacting the consumer
                    reporting agency identified above directly. By signing below, you acknowledge receipt of{' '}
                    <a href="https://www.labor.ny.gov/formsdocs/wp/correction-law-article-23a.pdf" target="_blank" rel="noopener noreferrer">
                        Article 23-A
                    </a>{' '}
                    of the New York Correction Law.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>New York City residents/applicants only:</strong> You acknowledge and authorize the Employer to provide any notices required by
                    federal, state or local law to you at the address(es) and/or email address(es) you provided to the Employer.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>Washington State applicants only:</strong> You also have the right to request from the consumer reporting agency a written summary
                    of your rights and remedies under the Washington Fair Credit Reporting Act.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>Minnesota and Oklahoma applicants only:</strong> Please check the box below if you would like to receive a copy of a consumer report
                    if one is obtained by the Company.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>San Francisco applicants only:</strong> Please click below for the San Francisco Fair Chance Act Notice. -{' '}
                    <a href="https://s3.amazonaws.com/checkr/public/SFFairChanceNotice.pdf" target="_blank" rel="noopener noreferrer">
                        English
                    </a>{' '}
                    -{' '}
                    <a href="https://s3.amazonaws.com/checkr/public/SFOrdinance-Spanish.pdf" target="_blank" rel="noopener noreferrer">
                        Spanish
                    </a>{' '}
                    -{' '}
                    <a href="https://s3.amazonaws.com/checkr/public/SFOrdinance-Tagalog.pdf" target="_blank" rel="noopener noreferrer">
                        Tagalog
                    </a>{' '}
                    -{' '}
                    <a href="https://s3.amazonaws.com/checkr/public/SFOrdinance-Chinese.pdf" target="_blank" rel="noopener noreferrer">
                        Chinese
                    </a>
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>Los Angeles applicants only:</strong> Please click{' '}
                    <a href="https://bca.lacity.org/Uploads/fciho/Notice%20to%20Applicants%20and%20Employees%20for%20Private%20Employers.pdf">here</a> for the
                    Los Angeles Notice to Applicants and Employees for Private Employers.
                </span>
            </p>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/assets/authorization.jsx